import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { CircularProgress } from "@mui/material";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";

const SendToOemModal = ({ show, handleClose, columnData, callApi }) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [selectedCourier, setSelectedCourier] = useState("");
  const [loading, setLoading] = useState(false);
  const [courierData, setCourierData] = useState([]);
  const [error, setError] = useState("");

  const handleBack = () => {
    handleClose();
    setSelectedCourier("");
  };

  const handleRadioChange = (name) => {
    setSelectedCourier(name);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    callApi(selectedCourier);
  };

  useEffect(() => {
    if (show) {
      fetchOEMData();
    }
  }, [show]);

  const fetchOEMData = async () => {
    setLoading(true);

    try {
      const payload = {
        username: loggedInUserName,
        orderId: columnData?.id,
        sourcePincode: columnData?.consignorPincode,
        destinationPincode: columnData?.consigneePincode,
        paymentMode: columnData?.paymentMode,
        express: columnData?.expressType,
        shipmentLength: columnData?.shipmentLength,
        shipmentWidth: columnData?.shipmentWidth,
        shipmentHeight: columnData?.shipmentHeight,
        shipmentWeight: columnData?.shipmentWeight,
        codAmount: Number(columnData?.codAmount),
      };

      const response = await axiosPostApi(
        apiList.OEM_RATE_CALCULATION,
        payload
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        const charges =
             response?.data?.data?.[0]?.carrierwiseCharges || [];

        const SHOW_ALL_COURIERS_FOR_TESTING = true;

        // ❌ Temporarily hidden couriers (by prefix)
        const hiddenCourierPrefixes = ["DTDC", "XBees"];

        const filteredCharges = SHOW_ALL_COURIERS_FOR_TESTING 
        ? charges 
        : charges.filter(
          (item) =>
            !hiddenCourierPrefixes.some((prefix) =>
              item?.carrierName?.startsWith(prefix)
            )
        );

        setCourierData(filteredCharges);
        setError(response?.data?.data?.[0] || "No courier details available.");
      } else {
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Failed to fetch data",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setCourierData([]);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "660px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <LocalShippingOutlinedIcon
                    style={{ color: "#ff7a00", fontSize: "28px" }}
                  />
                  <h5 className="modal-title main-title font-medium">
                    Courier Company
                  </h5>
                </div>
                <HighlightOffIcon
                  onClick={handleBack}
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
              </div>
              <form onSubmit={handleSubmit}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  {loading ? (
                    <CircularProgress />
                  ) : courierData && courierData?.length > 0 ? (
                    <div
                      className="table-container max-h-[550px] overflow-auto custom-scrollbar"
                      style={{ width: "100%" }}
                    >
                      <div className="table-wrapper">
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th
                                style={{ textAlign: "center" }}
                                className="!bg-[#ffe8d4]"
                              >
                                Select
                              </th>
                              <th className="!bg-[#ffe8d4]">Name</th>
                              <th
                                className="!bg-[#ffe8d4]"
                                style={{ textAlign: "center" }}
                              >
                                Priority
                              </th>
                              <th className="!bg-[#ffe8d4]">Estimate Date</th>
                              {/* <th
                                className="!bg-[#ffe8d4]"
                                style={{ textAlign: "center" }}
                              >
                                Total
                              </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {courierData?.map((item, index) => (
                              <tr key={index}>
                                <td style={{ textAlign: "center" }}>
                                  <input
                                    type="radio"
                                    name="courier"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      cursor: "pointer",
                                    }}
                                    checked={
                                      selectedCourier === item.carrierName
                                    }
                                    onChange={() =>
                                      handleRadioChange(item.carrierName)
                                    }
                                  />
                                </td>
                                <td>{item.carrierName}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.priority}
                                </td>
                                <td>{item.estimatedDd}</td>
                                {/* <td style={{ textAlign: "center" }}>
                                  {item.charges} ₹
                                </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#888",
                        fontStyle: "italic",
                      }}
                    >
                      {error?.response || "No courier details available."}
                    </div>
                  )}
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-[8px]"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit !rounded-[8px]"
                    disabled={!selectedCourier}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SendToOemModal;
